var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"foot-box"},[_c('div',{staticClass:"top-txt"},[_vm._v("\n      经营性网站备案信息  |  中国互联网举报中心  |  网络110报警服务\n    ")]),_vm._v(" "),_c('el-divider'),_vm._v(" "),_c('div',{staticClass:"foot-txt"},[_vm._v("\n      Copyright © 建成工程咨询股份有限公司\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e02c91d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageFooter.vue
// module id = null
// module chunks = 